import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Hook simples para obter o eventEditionCode do Redux
 *
 * Este hook apenas lê o valor do state sem disparar ações.
 * Use este hook em componentes que apenas precisam ler o código do evento.
 *
 * Para carregar/atualizar os dados do contrato, use useEventEditionCode no componente pai.
 *
 * @returns {string|undefined} eventEditionCode - Código da edição do evento
 *
 * @example
 * const eventCode = useEventCode();
 *
 * if (eventCode) {
 *   console.log("Código do evento:", eventCode);
 * }
 */
const useEventCode = () => {
  const { contractInfo } = useSelector((state) => state.contract);

  const eventCode = useMemo(
    () => contractInfo?.eventEditionCode,
    [contractInfo],
  );

  return eventCode;
};

export default useEventCode;
